import React from 'react';
import ReactDOM from 'react-dom';
import resolvePath from '../../../../misc/resolvePath';
import ButtonLink from '../../../elements/ButtonLink';
import { dialogAlert } from '../../../elements/Dialog/dialogs';
import Scrollable from '../../../elements/Scrollable';
import Validate from '../../../validate/Validate';
import WaitWhileBusy from '../../../WaitWhileBusy';
import Screen from '../../Screen';
import checkCondition from '../common/checkCondition';
import connectForm from '../common/connectForm';
import SuccessScreen from '../EventFormCompletionScreen';
import Footer from './Footer';
import Header from './Header';
import Question from './Question';

class EventFormResponse extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            groupIndex: 0,
            highlightErrors: false,
            showSuccessScreen: false,
        };
    }
    componentDidUpdate() {
        if (this.state.highlightErrors) {
            this.highlightTimeout = setTimeout(() => {
                this.setState({ highlightErrors: false });
            }, 1000);
        }
    }
    componentWillUnmount() {
        if (this.props.answer && !this.props.answer.hasData) {
            // No data present in answer: delete form
            app.store.dispatch(
                app.actions.forms.deleteResponse(this.props.answer.UID)
            );
        }
    }
    render() {
        if (this.state.showSuccessScreen) {
            return <SuccessScreen {...this.props} />;
        }

        let { event, form, answer, i18n } = this.props,
            group = form.groups[this.state.groupIndex],
            header = (
                <Header
                    event={event}
                    form={form}
                    group={group}
                    groupIndex={this.state.groupIndex}
                />
            ),
            footer = (
                <Footer
                    event={event}
                    form={form}
                    group={group}
                    groupIndex={this.state.groupIndex}
                    i18n={i18n}
                    hasNext={this.hasNextGroup()}
                    onGoPrev={this.handlePrevButton.bind(this)}
                    onGoNext={this.handleNextButton.bind(this)}
                />
            );

        return (
            <Screen tagName="form" header={header} footer={footer}>
                <Scrollable>
                    <div className="content">
                        {_(group.questions)
                            .filter(
                                (question) =>
                                    !question.enable_condition ||
                                    checkCondition(
                                        answer.answers,
                                        question.enable_condition
                                    )
                            )
                            .map((question) => (
                                <Question
                                    event={event}
                                    question={question}
                                    questions={_(form.groups)
                                        .map((group) => group.questions)
                                        .flatten()
                                        .value()}
                                    key={question.id}
                                    value={_(answer).get(
                                        `answers[${question.id}]`
                                    )}
                                    hasError={
                                        this.state.highlightErrors &&
                                        _(answer).get(`errors[${question.id}]`)
                                    }
                                    onChange={this.handleAnswerChange.bind(
                                        this,
                                        question.id
                                    )}
                                    formAnswer={answer.answers}
                                />
                            ))
                            .value()}
                        {!this.hasNextGroup() ? (
                            <div>
                                <br />
                                <br />
                                <br />
                                <ButtonLink
                                    style={event._local.styles.button}
                                    onClick={this.handleSendAnswer.bind(this)}
                                >
                                    {group.save_button_label}
                                </ButtonLink>
                            </div>
                        ) : null}
                    </div>
                </Scrollable>
            </Screen>
        );
    }
    async handleSendAnswer() {
        if (!_(this.props.answer.errors).values().value().length) {
            let group = this.props.form.groups[this.state.groupIndex];
            if (
                !group.proceed_condition ||
                !group.proceed_condition.length ||
                checkCondition(
                    this.props.answer.answers,
                    group.proceed_condition
                )
            ) {
                this.setState({ showSuccessScreen: true });
                app.store.dispatch(
                    app.actions.forms.sendResponse(this.props.answer.UID)
                );
            } else {
                await dialogAlert(group.proceed_condition_error_label);
            }
        } else {
            this.setState({ highlightErrors: true });
        }
    }
    handleAnswerChange(questionId, value) {
        app.store.dispatch(
            app.actions.forms.setValue(this.props.answer.UID, questionId, value)
        );
    }
    handlePrevButton() {
        let { form } = this.props;
        if (this.hasPrevGroup()) {
            this.setState({
                groupIndex: this.state.groupIndex - 1,
            });
        } else {
            app.history.push(resolvePath(app.history.location.pathname, '..'));
        }
    }
    async handleNextButton() {
        let group = this.props.form.groups[this.state.groupIndex],
            isGroupValid = !_(group.questions)
                .map((question) => this.props.answer.errors[question.id])
                .compact()
                .value().length;
        if (isGroupValid) {
            if (
                !group.proceed_condition ||
                !group.proceed_condition.length ||
                checkCondition(
                    this.props.answer.answers,
                    group.proceed_condition
                )
            ) {
                if (this.hasNextGroup()) {
                    this.setState({
                        groupIndex: this.state.groupIndex + 1,
                    });
                }
            } else {
                await dialogAlert(group.proceed_condition_error_label);
            }
        } else {
            clearTimeout(this.highlightTimeout);
            this.setState({ highlightErrors: true });
        }
    }
    hasPrevGroup() {
        return this.props.form.groups[this.state.groupIndex - 1];
    }
    hasNextGroup() {
        return this.props.form.groups[this.state.groupIndex + 1];
    }
}

const ConnectedEventForm = connectForm(EventFormResponse);

export default (props) => (
    <Validate
        validate={(state) => {
            let answer = _(state).get(
                `forms.drafts[${props.match.params.formAnswer}]`
            );
            if (props.match.params.formAnswer) {
                if (!answer) {
                    throw new Error(
                        'Form answer ' +
                            props.match.params.formAnswer +
                            ' not found'
                    );
                } else if (answer.formId != props.match.params.formId) {
                    throw new Error(
                        "Form answer doesn't belong to form.id = " +
                            props.match.params.formId
                    );
                }
            }
        }}
    >
        <WaitWhileBusy>
            <ConnectedEventForm {...props.match.params} />
        </WaitWhileBusy>
    </Validate>
);
